"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
var entity_1 = require("./entity");
var urlHelper_1 = require("../../utils/urlHelper");
var Video = /** @class */ (function (_super) {
    __extends(Video, _super);
    function Video() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Video.prototype.getStatusLabel = function () {
        switch (this.videoStatus) {
            case 'pending':
                return 'Várakozás a letöltésre...';
            case 'processing':
                return 'Áttöltés folyamatban...';
            case 'completed':
                return 'Befejezve';
            case 'error':
                return 'Az áttöltés sikertelen volt';
            default:
                return 'Ismeretlen státusz';
        }
    };
    Video.prototype.getConvertStatusLabel = function () {
        switch (this.convertStatus) {
            case 'processing':
                return 'Konvertálás folyamatban';
            case 'failed':
                return 'A konvertálás nem sikerült';
            case 'error':
                return 'Hiba történt a videó konvertálásakor';
            case 'completed':
                return 'Befejezve';
            case 'pending':
            default:
                return 'Várakozás a konvertálásra...';
        }
    };
    Video.prototype.getUrl = function () {
        return urlHelper_1.default.getUrl(this.videoName);
    };
    return Video;
}(entity_1.Entity));
exports.Video = Video;
